// Copyright (c) 2023 embyt GmbH. All rights reserved.
// Author: Marc Planeck
import * as React from "react";

import AppStateView from "view/comp/AppState";
import LoginForm from "view/comp/LoginForm";
import LoginLayout from "view/layout/LoginLayout";

export default function Login() {
  return (
    <LoginLayout>
      <LoginForm />
      <AppStateView />
    </LoginLayout>
  );
}
